import React from 'react';
import { StyleSheet } from 'react-native';

import { blurTargetRefPlayer } from '@/components/ui/tabbar/tabbar';
import { STRINGS } from '@/constants/strings';
import { ListPlayersScreen } from '@/features/player/screens/list-players-screen';
import { PlayerProfileScreen } from '@/features/player/screens/player-profile-screen';
import { PlayerStackParamList } from '@/navigations/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { BlurTargetView } from 'expo-blur';

const Stack = createNativeStackNavigator<PlayerStackParamList>();

export function PlayerStackNavigator() {
  return (
    <BlurTargetView ref={blurTargetRefPlayer} style={styles.blurTarget} collapsable={false}>
      <Stack.Navigator
        initialRouteName="PlayerList"
        screenOptions={{
          headerShown: false,
          title: STRINGS.appDocumentTitle,
        }}>
        <Stack.Screen name="PlayerList" component={ListPlayersScreen} />
        <Stack.Screen name="PlayerProfile" component={PlayerProfileScreen} />
      </Stack.Navigator>
    </BlurTargetView>
  );
}

const styles = StyleSheet.create({
  blurTarget: {
    flex: 1,
  },
});
